const { setDb } = require('./services/db');

const initShared = (db, firebase) => {
  setDb(db, firebase);
};

module.exports = { initShared };
